<template>
	<table class="table table-sm mb-0">
		<thead>
			<tr>
				<th colspan="2"><slot name="title"></slot></th>
				<th class="text-right">{{ $t('invoice.supplier_ventilation2_debit') }}</th>
				<th class="text-right">{{ $t('invoice.supplier_ventilation2_credit') }}</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(line, index) in lines" :key="index">
				<td>{{ line.account }}</td>
				<td>{{ line.label }}</td>
				<td class="text-right">{{ line.debit }}</td>
				<td class="text-right">{{ line.credit }}</td>
			</tr>
		</tbody>
		<tfoot v-if="total">
			<tr>
				<th colspan="2">{{ $t('invoice.supplier_ventilation2_total') }}</th>
				<th class="text-right">{{ total.debit }}</th>
				<th class="text-right">{{ total.credit }}</th>
			</tr>
		</tfoot>
	</table>
</template>


<script type="text/javascript">
	/**
	 * Lignes d'une écriture comptable, montants déjà formatés : écritures passées au FEC comme
	 * mouvements à venir d'une ventilation.
	 */
	export default {
		name: "InvoiceSupplierFecLines",

		props: {
			lines: { type: Array, default: () => ([]) },
			total: { type: Object, default: null }
		}
	}
</script>
